<script>
export default {
    name: 'UiButton',
    props: {
        rippleDuration: {
            type: Number,
            default: 300,
        },
        tag: {
            type: String,
            default: 'button',
        },
    },
    data() {
        return {
            animationComplete: false,
        };
    },
    methods: {
        onButtonClick(event) {
            if (this.animationComplete) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (this.$el.classList.contains('disabled')) {
                return;
            }

            const ripple = document.createElement('div');
            ripple.classList.add('circle');
            ripple.setAttribute('style', `top:${event.offsetY - 15}px; left:${event.offsetX - 15}px`);
            this.$el.classList.add('btn-ripple-wrap');
            this.$el.appendChild(ripple);

            setTimeout(() => {
                this.$el.classList.remove('btn-ripple-wrap');
                this.$el.removeChild(ripple);
                this.animationComplete = true;
                this.$nextTick(() => {
                    this.$emit('click');
                    this.$el.click();
                    this.animationComplete = false;
                });
            }, this.rippleDuration);
        },
    },
    render(h) {
        return h(
            this.tag,
            {
                class: ['btn'],
                on: {
                    click: this.onButtonClick,
                },
            },
            this.$slots.default,
        );
    },
};
</script>

<style lang="scss">
    @import "common/scss/palette";
    @import "common/scss/variables";
    @import "common/scss/variables/v2/buttons";

    $circle-md: 30px;
    $animation-normal: 2.5s;

    button {
        position: relative;
        cursor: pointer;
    }

    .btn-ripple-wrap {
        overflow: hidden;
    }

    .btn {
        @include button-base($space-xxs, $btn-width-md);

        &.btn-primary {
            @apply text-size-4 leading-none text-white font-semibold;
            @include button-background($primary-low, $primary-high);
            @include button-layering ($shadow-bump, $shadow-level-3);

            &.rounded {
                border-radius: 999px;
            }

            &:not(.rounded) {
                border-radius: $border-curve-lg !important;
            }

            &.purple {
                @include button-background($blue, $purple);
                @include button-layering (
                        (
                            depth: map-get($shadows-bump-map, depth),
                            blur: map-get($shadows-bump-map, blur),
                            color: rgba($purple, 0.4)
                        ),
                        (
                            depth: map-get($shadows-level-3-map, depth),
                            blur: map-get($shadows-level-3-map, blur),
                            color: rgba($pink, 0.4)
                        )
                );
            }

            &.sm {
                @apply text-size-6 leading-none;
            }
        }

        &.btn-secondary {
            height: 40px;
            border-radius: 20px;
            @apply text-size-6 leading-none font-semibold text-white;
            @include button-background(darken($purple, 10%), $purple);
            @include button-layering ($shadow-bump, $shadow-level-2);
        }

        &.btn-flat {
            @apply text-size-6 leading-none font-semibold text-white bg-sky-blue rounded;
        }

        .circle {
            position: absolute;
            width: $circle-md;
            height: $circle-md;
            background: rgba($white, .7);
            border-radius: $rounded-curve;
            border: 10px solid $white;
            animation: scale-circle $animation-normal;
            transform: inherit;
            pointer-events: none;
        }

        &:not(.btn-text):disabled {
            color: $white !important;
            background: $dust !important;
            box-shadow: none !important;
            border: 0 !important;
            cursor: not-allowed !important;
        }

        > * {
            pointer-events: none;
        }

        @keyframes scale-circle {
            from {
                transform: inherit;
                transform: scale(.2);
                opacity: 0.2;
            }
            to {
                transform: inherit;
                transform: scale(100);
                opacity: 0;
            }
        }
    }
</style>
